
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/framework-strategy/done",
      function () {
        return require("private-next-pages/download/framework-strategy/done/index.tsx");
      }
    ]);
  